import React, { PureComponent } from "react";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useState, useEffect } from "react";
import { barChart, analysisBest, teamNames } from "../Utils/demoAnalysis";
import { analysisDescription, chartLabel } from "../Utils/functions";
import { Leagues_getColor } from "../Utils/functions";
import { Link } from "react-router-dom";
import "../../assets/analysis.css";

const PlayerBarChart = ({ chartType, player_score, player_name }) => {
  const [chartData, setChartData] = useState([]);
  const [playerLevel, setPlayerLevel] = useState({});
  const [selectedGames, setSelectedGames] = useState(null);

  useEffect(() => {
    const data = barChart(chartType, player_score);
    setChartData(data);
    setPlayerLevel(analysisDescription(player_score));
  }, [chartType, player_score]);

  return (
    <div className="analysis-bar-chart">
      <h3>Career Totals</h3>
      <div style={{ height: "300px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            layout="vertical"
            width={730}
            height={250}
            data={chartData}
            onClick={(data) => {
              if (data && data.activePayload) {
                setSelectedGames(data.activePayload[0].payload.name);
              }
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis dataKey="name" type="category" />
            <Tooltip />
            <Legend />
            <Bar
              dataKey="games"
              fillOpacity={0.8}
              name="Games Played At This Level"
              shape={(props) => {
                const { x, y, width, height, name } = props;
                return (
                  <Rectangle
                    {...props}
                    fill={Leagues_getColor(props.payload.name)}
                  />
                );
              }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {selectedGames && (
        <div className="analysis-breakdown-container">
          <h4 className="analysis-breakdown-title">
            Games at {selectedGames} Level:{" "}
            {chartData.find((item) => item.name === selectedGames)?.games || 0}
          </h4>
          <div className="analysis-breakdown-list">
            {[
              ...Array(
                chartData.find((item) => item.name === selectedGames)?.games ||
                  0
              ),
            ].map((_, index) => (
              <Link
                key={index}
                to="/game/most-recent-game#game-stats"
                className="analysis-breakdown-item"
              >
                vs {teamNames[Math.floor(Math.random() * teamNames.length)]}
              </Link>
            ))}
          </div>
        </div>
      )}

      <p className="analysis-bar-chart-text">
        {player_name}'s average {chartLabel(chartType)} is at the{" "}
        <span
          style={{
            textDecoration: `4px underline ${playerLevel.color}`,
            fontWeight: "bold",
            color: playerLevel.color,
          }}
        >
          {playerLevel.level}.
        </span>{" "}
        <span style={{ fontWeight: "bold" }}>
          <br />
          <br />
          {analysisBest(playerLevel.level, chartType).percentage}%
        </span>{" "}
        of {player_name}'s individual {chartLabel(chartType)} performances
        recorded are{" "}
        <span
          style={{
            textDecoration: `4px underline ${playerLevel.color}`,
            fontWeight: "bold",
            color: playerLevel.color,
          }}
        >
          {playerLevel.level}.
        </span>
        {". "}
      </p>
    </div>
  );
};

export default PlayerBarChart;
